// extracted by mini-css-extract-plugin
export default {"Body":"_Body--BYU4v","BodyContainer":"_BodyContainer--b2jxU","BodyText":"_BodyText--SW2RW","WarningIcon":"_WarningIcon--hYSX1","ConfirmButton":"_ConfirmButton--jVbam"};